<template>
  <div class="newhome">
    <div class="newhome_banner"></div>
    <!-- 线上专项展厅 -->
    <div class="newhome_pub">
      <div class="m">
        <div class="newhome_pub_tit">
          <h2>线上专项展厅</h2>
          <router-link to="/zxzt">查看更多</router-link>
        </div>
        <div class="newhome_pub_content">
          <zxzt :list="hot1" />
        </div>
      </div>
    </div>
    <!-- 线上综合展厅 -->
    <div class="newhome_pub bg_gary">
      <div class="m">
        <div class="newhome_pub_tit">
          <h2>线上综合展厅</h2>
          <router-link to="/zhzt">查看更多</router-link>
        </div>
        <div class="newhome_pub_content">
          <zhzt :list="hot2" />
        </div>
      </div>
    </div>
    <!-- 线上专项展厅 -->
    <div class="newhome_pub">
      <div class="m">
        <div class="newhome_pub_tit">
          <h2>更多专题</h2>
        </div>
        <div class="newhome_pub_content">
          <ul class="gdzt">
            <li class="gdzt_item" v-for="item in list">
              <a :href="item.href" target="_blank">
                <img :src="item.src" />
                <p>{{item.name}}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zxzt from "@/components/list_item/zxzt/list";
import zhzt from "@/components/list_item/xs_zhzt/list";
import c1 from '@/assets/img/newhome/c1.jpg';
import c2 from '@/assets/img/newhome/c2.jpg';
import c3 from '@/assets/img/newhome/c3.jpg';
import c4 from '@/assets/img/newhome/c4.jpg';
import c5 from '@/assets/img/newhome/c5.jpg';
export default {
  components: {
    zxzt,
    zhzt
  },
  data() {
    return {
      hot1:[],
      hot2:[],
      list:[
        {
          name:'中国高校毕业作品百校联展',
          src:c1,
          href:'http://zaizhan.cn/#/home'
        },
        {
          name:'校企合作——大业设计',
          src:c4,
          href:'https://mp.weixin.qq.com/s/BCCMPyjJjYPdnXc0zVkm9Q'
        },
        {
          name:'粤港澳大湾区产业游学',
          src:c3,
          href:'https://mp.weixin.qq.com/s/a3jISgHOMmT6VZ6mBS03kA'
        },
        {
          name:'校企合作——念响传媒',
          src:c5,
          href:'https://mp.weixin.qq.com/s/V7LDwHqBHEOn-NyBEt23dw'
        },
        {
          name:'在线免费版权登记入口',
          src:c2,
          href:'http://zaizhan.cn/#/copyright_protection'
        },
      ]
    };
  },
  created(){
    this.getHot1();
    this.getHotOpus();
  },
  methods:{
    //线上专项展厅
    getHot1(){
      let params = {
        pageSize: 6,
        is_2020:true
      }
      this.api.getHotExhibitions(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.hot1 = res.obj.list;
      })
    },
     //线上综合展厅
    getHotOpus(){
      let params = {
        pageSize: 8,
        is_common:true
      }
      this.api.getHotOpus(params).then(res=>{
        if(res.error['err_code'] !== 0) return;
        this.hot2 = res.obj.list;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.newhome_banner {
  height: 700px;
  background: url("~@/assets/img/newhome/b1.png") no-repeat center;
  background-size: cover;
}
.newhome_pub {
  background: #fff;
  padding:0 0 40px;
  .newhome_pub_tit {
    padding: 79px 0 40px;
    display: flex;
    justify-content: space-between;
    h2 {
      font-size: 34px;
      color: #111;
    }
    a {
      font-size: 20px;
      color: #0057ff;
    }
  }
}
.newhome_pub.bg_gary{
  background: #F5F5F5;
  padding:0 0 20px;
}
.gdzt {
  display: flex;
  flex-wrap: wrap;
  .gdzt_item {
    display: flex;
    margin-right: 20px;
    a {
      width: 224px;
      img {
        width: 224px;
        height: 168px;
        background: #c1cbe7;
      }
      p {
        font-size: 16px;
        color: #333;
        padding: 19px 0 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }
  .gdzt_item:nth-child(5n){
    margin-right: 0;
  }
}
</style>